














































































import { defineComponent } from '@nuxtjs/composition-api';
import useCartCookie from '@shared/composables/useCartCookie';
import {
  lockPageScrollOnMobileOnly,
  unlockPageScrollOnMobileOnly,
} from '@shared/composables/useUiHelpers';
import useUiState from '@shared/composables/useUiState';
import { BaseCollectedProduct, BaseSidebar, UCIcon } from '@shared/ui';
import { cartGetters } from '@unified-commerce/gpc-vue-storefront-shopify';

import RecentlyAddedSidebarActions from '~/components/RecentlyAddedSidebar/RecentlyAddedSidebarActions.vue';

export default defineComponent({
  name: 'AddedProductSidebar',
  components: {
    RecentlyAddedSidebarActions,
    BaseSidebar,
    BaseCollectedProduct,
    UCIcon,
  },
  setup() {
    const { isRecentlyAddedSidebarOpen, recentlyAddedProduct } = useUiState();
    const { cart } = useCartCookie();

    const closeAddedProductSidebar = () => useUiState().setRecentlyAddedProduct(null);

    return {
      isRecentlyAddedSidebarOpen,
      recentlyAddedProduct,
      cartGetters,
      cart,
      closeAddedProductSidebar,
    };
  },
  watch: {
    isRecentlyAddedSidebarOpen(updatedSidebarState) {
      if (updatedSidebarState) {
        lockPageScrollOnMobileOnly();
      } else {
        unlockPageScrollOnMobileOnly();
      }
    },
  },
});
